// export class StatoProcedura {
export enum StatoProcedura {
  APPROVATO = 'APPROVATO',
  APPROVATA = 'APPROVATA',
  ELIMINATA = 'ELIMINATA',
  ELIMINATO = 'ELIMINATO',
  CANCELLATO = 'CANCELLATO',
  ERRORE = 'ERRORE',
  EVASA = 'EVASA',
  LAVORATO = 'LAVORATO',
  LAVORATA = 'LAVORATA',
  NUOVA = 'NUOVA',
  NUOVO = 'NUOVO',
  PRE_APPROVATO = 'PRE_APPROVATO',
  PRE_APPROVATA = "PRE_APPROVATA",
  DA_PRE_APPROVARE = "DA_PRE_APPROVARE",
  REVISIONATA = 'REVISIONATA',
  REVISIONATO = 'REVISIONATO',
  RITARDO = 'RITARDO',
  NON_ASSEGNATO = 'NON_ASSEGNATO',
  BOZZA = 'BOZZA',
  DA_CONFERMARE = 'DA_CONFERMARE',
  RIFIUTATO = 'RIFIUTATO',
  CHIUSO = 'CHIUSO',
  DATI_INVIATI_A_SAP = 'DATI_INVIATI_A_SAP',
  ERRORE_SAP = 'ERRORE_SAP',
  IN_MODIFICA = 'IN_MODIFICA',
  
}